<template>
    <div>
        <section-header
            ref="selectHeader"
            title="Select a Column Variable (Optional)"
        ></section-header>
        <analysis-variable-selection
            ref="analysisVariableSelection"
            variableType="column"
            :title="'Include a Column Variable'"
            v-model="selectionModel.v.column"
            v-on:variableIsSelected="selectedVariableChanged"
            :theVariable="selectionModel.v.column"
        ></analysis-variable-selection>
        <app-navigator
            ref="appNavigator"
            :router="$router"
            nextButtonTitle="Select a variable to continue"
        ></app-navigator>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import current from '@/scripts/current';
import commonModelHelper from '@/scripts/commonModelHelper';
import store from '@/store';
import sectionHeader from '@/components/sub/sectionHeader';
import appNavigator from '@/components/layout/appNavigator';
import analysisVariableSelection from '@/components/analysisVariableSelection';

export default {
    components: {
        sectionHeader,
        appNavigator,
        analysisVariableSelection
    },
    created() {
        let vm = this;
        current.initializeCrossTabulationValues(vm);
        commonModelHelper.initializeStep(vm, 'columnvariable');
        vm.selectionModel = current.selectionModel;

        vm.isLoaded = true;
    },
    data: function () {
        var vm = this;

        return {
            selectionModel: null,
            isLoaded: false,
            store
        };
    },
    mounted() {
        let vm = this;
        let omittedVariables = commonModelHelper.getSelectedVariables(
            current.selectionModel,
            ['row']
        );
        vm.$refs.analysisVariableSelection.updateSelection({
            omittedVariables
        });
    },
    methods: { selectedVariableChanged }
};

function selectedVariableChanged(variable) {
    const vm = this;
    vm.selectionModel.v.column = variable;
    store.dispatch('selModel/setReadyForNextStep');
}
</script>

<style scoped>
.spaced-out {
    margin-top: 20px;
    margin-bottom: 20px;
}

.dropdown-menu label.radio input[type='radio'] {
    visibility: hidden;
}

.dropdown-menu label.radio {
    padding-left: 10px;
}
</style>
